// extracted by mini-css-extract-plugin
module.exports = {"iframe_box":"styles_iframe_box__2zcBs"};